import { getIsWebApp } from '@utils/postMessage'
import React from 'react'
import styled from 'styled-components'

/**
 * 모바일 웹의 레이아웃을 잡는 Template Wrapper 컴포넌트
 */

// padding 문자열에서 bottom 값을 추출하는 함수
const extractPaddingBottom = paddingStr => {
  if (typeof paddingStr !== 'number' && !paddingStr) return null

  let values = null

  if (typeof paddingStr === 'number') {
    values = [`${paddingStr}px`]
  }
  else {
    // padding 값 파싱
    values = paddingStr.trim().split(/\s+/)
  }

  // padding 형식에 따라 bottom 값 추출
  // padding: all;
  // padding: vertical horizontal;
  // padding: top horizontal bottom;
  // padding: top right bottom left;

  if (values.length === 1) return values[0] // 모든 방향 동일
  if (values.length === 2) return values[0] // 상하 동일
  if (values.length === 3) return values[2] // bottom 명시
  if (values.length === 4) return values[2] // bottom 명시

  return null
}

// 패딩 계산 함수
const calculatePadding = (style, isWebApp) => {
  // padding과 paddingBottom에서 값 추출
  let bottomPadding = style?.paddingBottom

  // paddingBottom이 없고 padding이 있는 경우
  if (
    !bottomPadding
    && (style?.padding || typeof style?.padding === 'number')
  ) {
    bottomPadding = extractPaddingBottom(style.padding)
  }

  // 숫자인 경우 px 단위 추가
  if (typeof bottomPadding === 'number') {
    bottomPadding = `${bottomPadding}px`
  }

  // 기본값 설정
  let paddingBottom = bottomPadding

  // 웹앱이 아니면 44px 추가
  if (isWebApp !== true) {
    paddingBottom = bottomPadding ? `calc(${bottomPadding} + 44px)` : '110px'
  }

  return paddingBottom
}

// 기본 스타일드 컴포넌트 정의
const StyledBodyWrapper = styled.div`
  max-width: 480px;
  padding: 20px;
  background-color: white;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
`

/**
 * 자동으로 isWebApp 상태를 감지하는 BodyWrapper
 */
const BodyWrapper = React.forwardRef((props, ref) => {
  const isWebApp = getIsWebApp({ navigator: window.navigator })
  const paddingBottom = calculatePadding(props.style, isWebApp)

  const style = {
    ...(props.style || {}),
    paddingBottom,
  }

  return (
    <StyledBodyWrapper
      ref={ref}
      className="body_wrapper"
      {...props}
      style={style}
    />
  )
})

export default BodyWrapper
